export default function FieldGroup({ title, caption, children }) {
  return (
    <section className="mb-5 last:mb-0">
      <div className="mb-3">
        <div className="label text-carbon-800">{title}</div>
        {caption && <div className="caption text-carbon-400 mt-1">{caption}</div>}
      </div>
      <div className="rounded-box border border-carbon-100 divide-y divide-carbon-100 bg-white">
        {children}
      </div>
    </section>
  );
}
